import { BetaPill } from "@gadgetinc/widgets";
import { useStyletron } from "baseui";
import { ParagraphSmall } from "baseui/typography";
import React, { useMemo } from "react";
import { ChatbotSession } from "web/src/client-state-trees/ChatbotSession";
import type { DocsInterfaceProps } from "../src/chrome/DocsInterface";
import { DocsInterface } from "../src/chrome/DocsInterface";
import { desiredDocsVersion } from "../src/chrome/nav/DocsVersionSelector";
import { ChatbotChat } from "../src/components/chatbot/ChatbotChat";

const Assistant = (props: DocsInterfaceProps) => {
  const appVersion = desiredDocsVersion(props.currentApp);

  const session = useMemo(
    () =>
      ChatbotSession.create({
        docsVersion: appVersion.id,
      }),
    [appVersion]
  );
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={false}>
      <main
        className={css({
          maxWidth: "48rem",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto",
          paddingTop: $theme.sizing.scale600,
          paddingLeft: $theme.sizing.scale600,
          paddingRight: $theme.sizing.scale600,
        })}
      >
        <ChatbotChat session={session} user={props.currentUser} />
        <ParagraphSmall $style={{ textAlign: "center", color: $theme.colors.contentTertiary }}>
          This AI assistant is <BetaPill>Alpha</BetaPill>. Please report any issues with the responses or functionality using the +1 / -1
          buttons!
        </ParagraphSmall>
      </main>
    </DocsInterface>
  );
};

export default Assistant;
